import store from '@/store';
import { ItemTwoUploaderMeta } from '@/types/form';
import { ItemFormSectionMeta } from '@forzoom/item-form/types/form';
import { ROUTE_NAME as USER } from '@/modules/user/constant';
import { ROUTE_NAME as DREAM } from '@/modules/dream/constant';
import { ROUTE_NAME as GAME } from '@/modules/game/constant';
import { ROUTE_NAME as TRIANGLE } from '@/modules/triangle/constant';
import { getQS } from './utils';
import querystring from 'querystring';
import {Toast} from "vant";
import { ShareOption } from '@/types/wx';

/**
 * 用于一些内部页面的路由
 */
export const ROUTE_NAME_INTERNAL = {
    QRCODE: 'internal_qrcode',
};

export const ROUTE_NAME = {
    DATA_VIEW : 'data_view',
    AUTH_LOGOUT: 'auth_logout',
    LOVER_RUN_POSTER: 'activity_lover_run_poster',
    ACTIVITY: 'ACTIVITY',
    ACTIVITY_10: 'ACTIVITY_10',
    ACTIVITY_11: 'ACTIVITY_11',
    ACTIVITY_12: 'ACTIVITY_12',
    ACTIVITY_MEMBER_MONITOR: 'activity_member_monitor',

    ADDRESS_LIST: 'address_list',
    ADDRESS_EDIT: 'address_edit',

    CONTRACT_REAL_NAME_VERIFY: 'CONTRACT_REAL_NAME_VERIFY',
    COIN_WITHDRAW: 'coin_withdraw',
    COIN_TALLY: 'coin_tally',
    COIN_WITHDRAW_ACCOUNT: 'coin_withdraw_account',
    COIN_INDEX: 'coin_index',
    COIN_TASK: 'coin_task',

    CREATE_TEAM_MONITOR_INFO: 'CREATE_TEAM_MONITOR_INFO',
    CREATE_TEAM_MONITOR_CHECK: 'CREATE_TEAM_MONITOR_CHECK',
    CREATE_TEAM_TEAM_INFO: 'CREATE_TEAM_TEAM_INFO',
    CREATE_TEAM_DIGI_CERT: 'CREATE_TEAM_DIGI_CERT',
    USER_PHONE_LOGIN: 'USER_PHONE_LOGIN',
    USER_PHONE_BINDING: 'USER_PHONE_BINDING', // 手机号绑定
    FEEDBACK_REPORT: 'FEEDBACK_REPORT',
    FEEDBACK_REPORT_RESULT: 'FEEDBACK_REPORT_RESULT',
    FEEDBACK: 'FEEDBACK',
    FEEDBACK_CATEGORY: 'FEEDBACK_CATEGORY',
    TEAM_MANAGE_LIST: 'TEAM_MANAGE_LIST',
    TEAM_MANAGE_DETAIL: 'TEAM_MANAGE_DETAIL',
    TEAM_MANAGE_INFLUENCE: 'TEAM_MANAGE_INFLUENCE',
    TEAM_RECRUIT_RANK: 'TEAM_RECRUIT_RANK',
    TEAM_SHARE: 'TEAM_SHARE',
    TEAM_DETAIL_NORMAL: 'TEAM_DETAIL_NORMAL',
    TEAM_DETAIL_HOME: 'TEAM_DETAIL_HOME',
    TEAM_DETAIL_STAT: 'team_detail_stat',
    USER_NOTIFICATION: 'USER_NOTIFICATION',
    USER_HOME: 'USER_HOME', // 个人中心
    USER_INFO: 'USER_INFO',
    USER_ADDRESS: 'USER_ADDRESS',
    USER_WITHDRAW_INFO: 'USER_WITHDRAW_INFO', // 提现管理
    USER_WITHDRAW_ACCOUNT: 'USER_WITHDRAW_ACCOUNT', // 提现管理
    USER_ACCOUNT: 'USER_ACCOUNT', // 账户信息
    USER_WALLET: 'USER_WALLET', // 用户钱包
    USER_CONVERTCOIN: 'USER_CONVERTCOIN', // 转跑币
    USER_ACCOUNT_DETAIL: 'USER_ACCOUNT_DETAIL', // 账户明细
    USER_ACCOUNT_WITHDRAW: 'USER_ACCOUNT_WITHDRAW', // 余额提现
    USER_SETTING: 'USER_SETTING', // 功能设置
    USER_CREDIT_POINTS: 'USER_CREDIT_POINTS', // 我的信用分
    USER_THIRD_PLAT: 'USER_THIRD_PLAT', // 跑步软件
    OTHER_SIGNIN: 'OTHER_SIGNIN', // 替他报名列表
    OTHER_SIGNIN_CANCEL: 'OTHER_SIGNIN_CANCEL', // 替他报名列表
    WIDTHDRAW_LIST: 'WIDTHDRAW_LIST',
    SIGN_IN_ENTER: 'SIGN_IN_ENTER',
    SIGN_IN: 'SIGN_IN', // 打卡
    NEW_SIGN_IN: 'NEW_SIGN_IN', // 打卡
    SIGN_IN_RESULT: 'SIGN_IN_RESULT',
    SIGN_IN_RECORD: 'SIGN_IN_RECORD',
    CHECK: 'CHECK',
    TEAM_INVITE_CARD: 'TEAM_INVITE_CARD',
    TEAM_DETAIL_MEMBERS: 'TEAM_DETAIL_MEMBERS',
    ACTIVITY_PAY: 'ACTIVITY_PAY',
    ACTIVITY_SEARCH: 'ACTIVITY_SEARCH',
    ACTIVITY_RUNNERS: 'ACTIVITY_RUNNERS',
    COMMUNITY: 'COMMUNITY',
    COMMUNITY_PUBLISH: 'COMMUNITY_PUBLISH',
    COMMUNITY_DETAIL: 'COMMUNITY_DETAIL',
    COMMUNITY_REPLY: 'COMMUNITY_REPLY',
    COMMUNITY_OFFLINE: 'COMMUNITY_OFFLINE',
    RANK_O: 'RANK_O',
    RANK_C: 'RANK_C',
    RANK: 'RANK',
    RANK_SHARE: 'RANK_SHARE',
    RANK_TEAM_24: 'RANK_TEAM_24',
    RANK_PLATFORM: 'rank_platform',
    ACTIVITY_INDEX: 'ACTIVITY_INDEX',
    ACTIVITY_LIST: 'ACTIVITY_LIST',
    ACTIVITY_LIST_O: 'ACTIVITY_LIST_O',
    ACTIVITY_DETAIL: 'ACTIVITY_DETAIL',
    ACTIVITY_DETAIL_24: 'ACTIVITY_DETAIL_24',
    ACTIVITY_DETAIL_HOME: 'ACTIVITY_DETAIL_HOME',
    ACTIVITY_PACKAGE: 'ACTIVITY_PACKAGE',
    ACTIVITY_SKUS: 'ACTIVITY_SKUS',
    ACTIVITY_RESULT: 'ACTIVITY_RESULT',
    ACTIVITY_OTHER: 'ACTIVITY_OTHER',
    ACTIVITY_DEPOSIT: 'ACTIVITY_DEPOSIT',
    ACTIVITY_DEPOSIT_HISTORY: 'ACTIVITY_DEPOSIT_HISTORY',
    ACTIVITY_PREVIOUS: 'ACTIVITY_PREVIOUS',
    ACTIVITY_NEWS: 'ACTIVITY_NEWS',
    ACTIVITY_EQUIPMENT: 'ACTIVITY_EQUIPMENT',
    ACTIVITY_EQUIPMENT_O: 'ACTIVITY_EQUIPMENT_O',
    ACTIVITY_TIPS: 'ACTIVITY_TIPS',
    TEAM_DETAIL_RANK: 'TEAM_DETAIL_RANK',
    SHOP_LOGISTIC: 'SHOP_LOGISTIC',
    SHOP_ORDER_LIST: 'SHOP_ORDER_LIST',
    SHOP_ORDER_LIST_OLD: 'SHOP_ORDER_LIST_OLD',
    CONSULT: 'CONSULT',

    MONITOR_ACTIVITY_LIST: 'monitor_activity_list',
    MONITOR_REDIRECT: 'monitor_redirect',
    MONITOR_SETTING_BEFORE: 'monitor_setting_before',
    MONITOR_SETTING: 'monitor_setting',
    MONITOR_QUESTION: 'monitor_question',
    MONITOR_RESULT: 'monitor_result',
    MONITOR_TEAM: 'monitor_team', // 队伍创建申请
    MONITOR_INTERVIEW: 'monitor_interview',

    TEAM_IDENTIFICATION: 'TEAM_IDENTIFICATION',
    TEAM_MANAGE_SIGNIN_DETAIL: 'TEAM_MANAGE_SIGNIN_DETAIL',
    TEAM_MANAGE_SIGNIN_CALENDAR: 'TEAM_MANAGE_SIGNIN_CALENDAR',
    ACTIVITY_SUBMIT_ORDER: 'ACTIVITY_SUBMIT_ORDER',
    ACTIVITY_PAY_FINISHED: 'ACTIVITY_PAY_FINISHED',
    ACTIVITY_QUESTION: 'ACTIVITY_QUESTION',
    ACTIVITY_REFUND: 'ACTIVITY_REFUND',
    ACTIVITY_CATEGORY: 'ACTIVITY_CATEGORY',
    MARKET_VALENTINE: 'MARKET_VALENTINE',
    MARKET_VALENTINE_CARD: 'MARKET_VALENTINE_CARD',
    ACTIVITY_SUBSCRIBE: 'ACTIVITY_SUBSCRIBE',
    ACTIVITY_CURRENT: 'ACTIVITY_CURRENT',
    ACTIVITY_CONFIRM_MEDAL: 'activity_confirm_medal',
    SUMMARY_HUNDRED_10: 'SUMMARY_HUNDRED_10',
    REPORT_HUNDRED_10: 'REPORT_HUNDRED_10',
    REPORT_HUNDRED_11: 'REPORT_HUNDRED_11',
    REPORT_HUNDRED_12: 'REPORT_HUNDRED_12',

    TRAINING_PLAN_INDEX: 'TRAINING_PLAN_INDEX',
    TRAINING_PLAN_DETAIL: 'TRAINING_PLAN_DETAIL',
    TRAINING_PLAN_SELECT: 'TRAINING_PLAN_SELECT',
    BADGE: 'BADGE',
    BADGE_DETAILS: 'BADGE_DETAILS',
    BADGE_CARD: 'BADGE_CARD',
    MALL: 'MALL',
    MONITOR_INVITE: 'MONITOR_INVITE',
    MONITOR_INVITE_TEAM: 'MONITOR_INVITE_TEAM',
    MONITOR_INVITE_TEAM_DEATIL: 'MONITOR_INVITE_TEAM_DEATIL',
    ACTIVITY_SELECT_TEAM: 'ACTIVITY_SELECT_TEAM',
    ACTIVITY_SELECT_TEAM1: 'ACTIVITY_SELECT_TEAM1',
    WISH_INDEX: 'WISH_INDEX',
    WISH_ADD: 'WISH_ADD',
    WISH_SELECTBG: 'WISH_SELECTBG',
    WISH_SUCCESS: 'WISH_SUCCESS',
    FEEDBACK_SIGNIN_APPEAL: 'FEEDBACK_SIGNIN_APPEAL',
    HUANGSHAN_INDEX: 'HUANGSHAN_INDEX',
    HUANGSHAN_INFO: 'HUANGSHAN_INFO',

    SHOP_ORDER_DETAIL: 'shop_order_detail',
    SHOP_ORDER_DETAIL_NEW: 'shop_order_detail_new',
    SHOP_ORDER_DETAIL_O: 'shop_order_detail_o',

    // 同城活动
    INTRA_CITY_LIST: 'INTRA_CITY_LIST',
    INTRA_CITY_CREATE: 'INTRA_CITY_CREATE',
    INTRA_CITY_CREATE_RESULT: 'INTRA_CITY_CREATE_RESULT',
    INTRA_CITY_DETAIL: 'INTRA_CITY_DETAIL',

    USER_CENTER: 'user_center',
    USER_FOLLOW_FAN: 'user_follow_fan',

    PLANT_TREE_INDEX: 'PLANT_TREE_INDEX',
    PLANT_TREE_LIST: 'PLANT_TREE_LIST',

    TESLA_INDEX: 'TESLA_INDEX',
    TESLA_LIST: 'TESLA_LIST',
    AFTER_SALE: 'AFTER_SALE',
    AFTER_SALE_LIST: 'AFTER_SALE_LIST',
    SELETE: 'SELETE',
    REPLACEMENT: 'REPLACEMENT',
    SELETE_SIZE: 'SELETE_SIZE',

    NUMBER_HOME: 'NUMBER_HOME',
    NUMBER_SELECT: 'NUMBER_SELECT',
    NUMBER_CUSTOM: 'NUMBER_CUSTOM',

    LUCKY_HOME: 'LUCKY_HOME',

    MEMBER: 'MEMBER',

    USER,

    DREAM,
    GAME,
    TRIANGLE,
};
export const STATIC_HOST = 'https://static.run100.runorout.cn';
export const URL_PATH = {
    /** 红黄色 run100 */
    LOGO: STATIC_HOST + '/meta/logo.jpg',
    /** 红黄色 run100 */
    LOGO1: STATIC_HOST + '/meta/logo.jpg',
    /** 橙色渐变 run */
    LOGO2: STATIC_HOST + '/meta/logo2.png',
    /** 白底红字 "百日跑 看到坚持的力量" */
    LOGO3: STATIC_HOST + '/meta/logo3.jpg',
    /** 红底白字 "百日跑 看到坚持的力量" */
    LOGO4: STATIC_HOST + '/meta/logo4.jpg',
    SHARE_LOGO_11: STATIC_HOST + '/meta/common/share_logo_11.png',
    /** 跑币规则说明 */
    // PAOBI: 'https://mp.weixin.qq.com/s/2LUD_zoaoMD90ztIw7VTkw',
    PAOBI: 'https://mp.weixin.qq.com/s?__biz=MzU5ODY4NjM3OQ==&mid=2247641808&idx=1&sn=4393391ba8bbc6b918bbe90f02044bf8&chksm=fe4c8514c93b0c02f981cdd7adee613c4b6609c1c3d2a27d8d79333e3e7b69626fb884f22a2b#rd',
    SHOP: 'https://shop90594089.youzan.com/v2/feature/XoOPfaVCU5',
    QRCODE_XIAO_TIAN_TIAN: 'https://static.run100.runorout.cn/meta/qrcode/xiao_tian_tian.jpg',
    RUNCOIN: 'https://mp.weixin.qq.com/s?__biz=MzU5ODY4NjM3OQ==&mid=2247657128&idx=1&sn=8aee0257d714e246c819463f4bebcd1d&chksm=fe4c496cc93bc07ac4b42a09f117573bf0adac929b0dc01d2f102b6cd628bcbf7af259248c90#rd',
    POINTS : 'https://mp.weixin.qq.com/s?__biz=MzU5ODY4NjM3OQ==&mid=2247657125&idx=1&sn=2badfd38e815b21f1a6dfd0e348c3370&chksm=fe4c4961c93bc077abab0914f18dcd2b17ec966887ee5d60b935acc202e5c74a5291f130795f#rd',
};

export const FILE_TYPE_USER_AVATAR = 'user_avatar';
export const FILE_TYPE_TEAM_AVATAR = 'team_avatar';
export const FILE_TYPE_TEAM_PHOTOS = 'team_photos';
export const FILE_TYPE_TEAM_GROUP_CODE = 'team_group_code';
export const FILE_TYPE_TEAM_MONITOR_CODE = 'team_monitor_code';
export const FILE_TYPE_SIGN_IN = 'sign_in';
export const FILE_TYPE_COMMUNITY = 'community_photo';
export const FILE_TYPE_FEEDBACK_REPORT = 'feedback_report';

export const CHECK_ACTION: {
    ACCEPT: 'accepted',
    REJECT: 'rejected',
    PASS: 'pass',
} = {
    ACCEPT: 'accepted',
    REJECT: 'rejected',
    PASS: 'pass',
};

// growingIO
// 支付成功
export const ID_ACTIVITY_PAY_SUCCESS = 'activity_pay_success';
// 基因支付成功
export const ID_GENE_PAY_SUCCESS = 'gene_pay_success';
// 支付/升级
export const VAR_ACTIVITY_PAY_SCENE = 'activity_pay_scene';
// 是否他人推荐报名
export const VAR_ACTIVITY_REFERRER_PAY = 'activity_referrer_pay';
// 基因支付场景
export const VAR_GENE_PAY_SCENE = 'gene_pay_scene';

export const GIO_ID = {
    APPLY_MONITOR: 'apply_monitor',
    ACTIVITY_CREATE_ORDER: 'activity_create_order',
    JOIN_TEAM_AFTER_PAY: 'join_team_after_pay', // 先报名后选队伍
};

export const KEY_AUTH_TOKEN = 'jwt';
export const KEY_GENE_POPUP = '11_gene_show_3';
export const KEY_LOGINUP = 'is_401_page';
// 登录前将要进入的path
export const KEY_LOGIN_NEXT = 'key_login_next';

export const LOGO = '';

export const WISH_SHARE_LOGO = 'https://static.run100.runorout.cn/meta/wish/share_icon.png';

/** 成为队长链接 */
export const URL_BE_MONITOR: {
    [activityId: string]: string,
} = {
    1: 'https://mp.weixin.qq.com/s/B8yF7QbjKNk6JSlYROXkew',
    2: 'https://mp.weixin.qq.com/s/2yalQX8hJbwA7Hx9IVOmMA',
    3: 'https://mp.weixin.qq.com/s/P2jusgnb0tVeaROV5XlGOQ',
    4: 'https://mp.weixin.qq.com/s/P2jusgnb0tVeaROV5XlGOQ',
};
/** 联想体脂秤链接 */
export const URL_LENOVO = 'https://pro.m.jd.com/wq/active/2heC29BJiMxVAS6usvJf2wRntc71/index.html';
/** 查作业规则 */
export const CHECK_RULE = 'http://mp.weixin.qq.com/s?__biz=MzU5ODY4NjM3OQ==&mid=100000364&idx=1&sn=0d8e60edd8e57d7e7283a12960ca2b07&chksm=7e412da84936a4beae4e0dac2252ba99ec9fe2b4ec80f776c5d06287d1dc120cfee0c29d5713#rd';
/** 邀请队长规则链接 */
export const URL_MONITOR_INVITE_RULR = 'https://mp.weixin.qq.com/s/2yalQX8hJbwA7Hx9IVOmMA';

/** serverId有效天数 */
export const WX_SERVER_ID_VALID_DAY = 3;

export const TYPE_SHARE_WORD_INVITE_USER = 1;
export const TYPE_SHARE_WORD_INVITE_MONITOR = 2;

export const SHARE_DESC = '万人坚持跑步打卡100天，看到坚持的力量';

export const datePopup: {
    [key: string]: string,
} = {
    '2019-12-13': '/meta/activity_3/popup/countdown/3.png',
    '2019-12-14': '/meta/activity_3/popup/countdown/2.png',
    '2019-12-15': '/meta/activity_3/popup/countdown/1.png',
    '2019-12-16': '/meta/activity_3/popup/countdown/0.png',
};

export const TEAM_LABELS: { [label: string]: {
    value: string;
    text: string;
    color: string;
    bg: string;
} } = {
    企业跑团: {
        value: '企业跑团',
        text: '企业跑团',
        color: '#4A90E2',
        bg: '#DDEDFF',
    },
    学校跑团: {
        value: '学校跑团',
        text: '学校跑团',
        color: '#FF9A0D',
        bg: '#FFF2E1',
    },
    社会跑团: {
        value: '社会跑团',
        text: '社会跑团',
        color: '#FF6924',
        bg: '#FFDEDE',
    },
};

// 允许超卖，由前端设置left_count
const emptyChoiceMap: {
    [choiceItemId: number]: boolean,
} = {
    // 46: true, // 男 39 黑/中灰
    // 47: true, // 男 40 黑/中灰
    // 48: true, // 男 41 黑/中灰
    // 49: true, // 男 42 黑/中灰
    // 68: true, // 男 45 宝兰/深蓝
    // 69: true, // 男 46 宝兰/深蓝
    // 85: true, // 女 36 薄荷绿/紫
    // 86: true, // 女 37 薄荷绿/紫
    // 87: true, // 女 38 薄荷绿/紫
    // 88: true, // 女 39 薄荷绿/紫
    // 89: true, // 女 40 薄荷绿/紫
};

export function getCreateTeamSections(levels: Activity.Level[]) {
    const sections: Array<ItemFormSectionMeta | ItemTwoUploaderMeta> = [
        {
            type: 'ItemCommonUploader',
            key: 'logo',
            props: {
                title: '上传战队头像',
                // @ts-ignore
                mode: 'input',
                httpRequest: async (image) => {
                    if (!image.file) {
                        return image;
                    }
                    const rdata = await store.dispatch('framework/configAndUploadToAliyun', {
                        file: image.file,
                        type: FILE_TYPE_TEAM_AVATAR,
                        square: true,
                    });
                    return rdata.data;
                },
            },
            validates: [
                { required: true, message: '请上传战队头像' },
            ],
        },
        {
            type: 'ItemCascader',
            key: 'city_id',
            props: {
                title: '战队城市',
                titleHint: '(请选择队伍所在地)',
                placeholder: '请选择',
                fetchList: (item) => {
                    // @ts-ignore 没有level或者level > 2时不返回了
                    if (item.level > 2) {
                        return [];
                    }
                    if (item.id === -1) {
                        return [];
                    }
                    if (item.id === 0) {
                    //     const extra = store.state.district.extraProvinceList;
                        return store.dispatch('getProvinceList').then((list) => {
                            return list;
                            // extra.concat(list);
                        });
                    }
                    return store.dispatch('getChildDistricts', {
                        id: item.id,
                    });
                },
            },
            validates: [
                { required: true, message: '请选择战队城市' },
            ],
        },
        {
            type: 'ItemInput',
            key: 'name',
            props: {
                title: '战队名称',
                placeholder: '不超过10个字，不用写地区名称',
                max: 10,
            },
            validates: [
                { required: true, message: '请输入战队名称' },
                { max: 10, message: '战队名称长度不能超过10个字' },
                {
                    fn: (value: any) => {
                        if (value.indexOf('官方') > -1 || value.indexOf('总部') > -1) {
                            Toast('名字中不能包含\'官方\'或者\'总部\'');
                            return false;
                        }
                        return true;
                    },
                },
            ],
        },
        {
            type: 'ItemInput',
            key: 'we_chat_id',
            props: {
                title: '微信号',
            },
            validates: [
                { required: true, message: '请输入微信号' },
            ],
        },
        {
            type: 'ItemButtonGroup',
            key: 'level_id',
            props: {
                title: '日打卡目标',
                titleHint: '(提交后，日打卡目标不可更改)',
                options: levels.map((level) => ({ value: level.id, text: level.name })),
            },
            validates: [
                { required: true, message: '请选择日打卡目标' },
            ],
        },
        {
            type: 'ItemTextarea',
            key: 'description',
            props: {
                title: '战队介绍',
                placeholder: '请介绍你自己能担任好队长的原因。例如：爱跑者联盟理事会成员，累计75场马拉松，全马PB355，半马PB149。多场马拉松的官方配速员。',
            },
            validates: [
                { required: true, message: '请输入战队介绍' },
            ],
        },
        // {
        //     type: 'ItemTwoUploader',
        //     key: 'qr_code',
        //     props: {
        //         title: '添加二维码',
        //         titleHint: '(用于让你的队员都能进你新建的微信群)',
        //         uploadHint: ['添加战队群二维码', '添加队长二维码'],
        //         mode: 'input',
        //         httpRequest: async (index, image) => {
        //             // @ts-ignore
        //             if (!image.file) {
        //                 return image;
        //             }
        //             const rdata = await store.dispatch('framework/configAndUploadToAliyun', {
        //                 // @ts-ignore
        //                 file: image.file,
        //                 type: index === 0 ? FILE_TYPE_TEAM_GROUP_CODE : FILE_TYPE_TEAM_MONITOR_CODE,
        //                 square: true,
        //             });
        //             return rdata.data;
        //         },
        //     },
        //     validates: [
        //         { required: true, message: '请上传二维码' },
        //         { fn: (value) => value.filter((item: ImageInfo) => item).length === 2, message: '请上传二维码' },
        //     ],
        // },
        // {
        //     type: 'ItemMultiUploader',
        //     key: 'photos',
        //     // @ts-ignore
        //     props: {
        //         // class="flat clearfix"
        //         title: '战队相册',
        //         mode: 'input',
        //         titleHint: '(展示你战队精神面貌的图片，能吸引更多人报名，战队创建后也可修改。)',
        //         httpRequest: async (image) => {
        //             // @ts-ignore
        //             if (image.file) {
        //                 const rdata = await store.dispatch('framework/configAndUploadToAliyun', {
        //                     // @ts-ignore
        //                     file: image.file,
        //                     type: FILE_TYPE_TEAM_PHOTOS,
        //                     square: true,
        //                 });
        //                 return rdata.data;
        //             }
        //             return {
        //                 key: image.key,
        //                 url: image.url,
        //             };
        //         },
        //         size: 9,
        //     },
        // },
    ];
    return sections;
}

export const STORAGE_KEY = {
    UPLOAD_MODE: 'upload_mode',
    // 是否已经展示过更换套餐弹窗
    CHANGE_PACKAGE_HAS_SHOW: 'change_package_has_show',
    // 获取地理位置信息
    GET_CURRENT_LOCATION: 'get_current_location',
};

export const ACTIVITY_MODE: {
    /** 百日跑 */
    UNIFIED: Activity.Mode;
    /** 线上赛 */
    ONLINE: Activity.Mode;
    /** 随时报 */
    FLEX: Activity.Mode;
    /** 追梦中国 */
    DREAM: Activity.Mode;
} = {
    UNIFIED: 'unified',
    ONLINE: 'online',
    FLEX: 'flex',
    DREAM: 'dream',
};

export async function loginFn() {
    const qs = getQS();
    // 在qs中添加hash
    qs.hash = encodeURIComponent(location.hash);
    // 尝试获取用户数据
    store.commit('startRequest');
    const loginRdata = await store.dispatch('auth/login', qs);
    console.log('target constant-inlogFn', loginRdata);
    store.commit('endRequest');
    if (loginRdata.status === 0) {
        // hash参数可以放弃
        delete qs.hash;
        const hasJwt = !!qs.jwt;
        delete qs.jwt;
        // 矫正url
        const posInHref = location.href.indexOf('?');
        if (posInHref === -1 || location.href.indexOf('#') < posInHref || hasJwt) {
            // location.replace(`${location.protocol}//${location.host}${location.pathname}?${querystring.stringify(qs)}${location.hash}`);
            const url = (`${location.protocol}//${location.host}${location.pathname}?${querystring.stringify(qs)}${location.hash}`);
            return {
                status: 0,
                name: url,
                replace: true,
            };
        } else {
            // 尝试获得basicInfo
            const state = store.state.user;
            if (!state.basicInfo) {
                const activityIds = store.getters['activity/activityIds'] as string[];
                store.dispatch('getProvinceList');
                await Promise.all([
                    store.dispatch('user/getBasicInfo'),
                    ...(activityIds.map((activityId) => store.dispatch('activity/getBasicInfo', {
                        activityId,
                    }))),
                ]);
            }
            return {
                status: 0,
                name: null,
            };
            // next();
        }
    } else if (loginRdata.status === 1) { // 准备执行重定向(例如OAuth)
        console.log('重定向地址', loginRdata.redirectUrl);
        const qs = getQS(loginRdata.redirectUrl);
        const nqs = getQS()
        console.log('target qs数据', qs, nqs);
        if(qs.redirect_uri) {
            // qs.redirect_uri = encodeURIComponent(qs.redirect_uri + '') + encodeURIComponent(location.hash === '#/' ? '' : location.hash)
            const search = Object.keys(nqs).map(key => `${key}=${nqs[key]}`)
            qs.redirect_uri = encodeURIComponent(qs.redirect_uri + '') + encodeURIComponent(search.join('&')) + encodeURIComponent(location.hash)
            console.log('target encode编译地址', encodeURIComponent(location.hash === '#/' ? '' : location.hash));
        }
        const host = loginRdata.redirectUrl.split('?')[0]
        console.log('target 重定向参数 host:', host, 'hash:', location.hash, 'qs: ', qs);
        const arr = Object.keys(qs).map(key => `${key}=${qs[key]}`)
        let redirectUrl = `${host}?${arr.join('&')}`
        console.log('target 修正的重定向地址', redirectUrl, arr.join('&'));
        return {
            status: 1,
            // name: loginRdata.redirectUrl,
            name: redirectUrl,
            replace: true,
        };
    } else if (loginRdata.status === 10000) {
        return {
            status: 10000,
            name: ROUTE_NAME.USER_PHONE_LOGIN,
        };
    }
}

export const CITY_LIST_POSTION = [
    {
        name: '北京',
        positionX: 657,
        positionY: 420,
        nameX: 609,
        nameY: 434,
    },
    {
        name: '内蒙古',
        positionX: 552,
        positionY: 408,
        nameX: 486,
        nameY: 410,
    },
    {
        name: '宁夏',
        positionX: 506,
        positionY: 476,
        nameX: 491,
        nameY: 500,
    },
    {
        name: '甘肃',
        positionX: 351,
        positionY: 412,
        nameX: 337,
        nameY: 436,
    },
    {
        name: '新疆',
        positionX: 210,
        positionY: 368,
        nameX: 156,
        nameY: 368,
    },
    {
        name: '西藏',
        positionX: 190,
        positionY: 578,
        nameX: 175,
        nameY: 603,
    },
    {
        name: '青海',
        positionX: 336,
        positionY: 504,
        nameX: 323,
        nameY: 532,
    },
    {
        name: '陕西',
        positionX: 532,
        positionY: 549,
        nameX: 518,
        nameY: 574,
    },
    {
        name: '河南',
        positionX: 617,
        positionY: 548,
        nameX: 599,
        nameY: 574,
    },
    {
        name: '安徽',
        positionX: 676,
        positionY: 588,
        nameX: 664,
        nameY: 612,
    },
    {
        name: '湖北',
        positionX: 611,
        positionY: 615,
        nameX: 561,
        nameY: 617,
    },
    {
        name: '江西',
        positionX: 660,
        positionY: 663,
        nameX: 647,
        nameY: 688,
    },
    {
        name: '湖南',
        positionX: 587,
        positionY: 673,
        nameX: 574,
        nameY: 697,
    },
    {
        name: '重庆',
        positionX: 521,
        positionY: 637,
        nameX: 506,
        nameY: 663,
    },
    {
        name: '四川',
        positionX: 446,
        positionY: 615,
        nameX: 395,
        nameY: 615,
    },
    {
        name: '云南',
        positionX: 401,
        positionY: 740,
        nameX: 386,
        nameY: 765,
    },
    {
        name: '贵州',
        positionX: 504,
        positionY: 693,
        nameX: 490,
        nameY: 718,
    },
    {
        name: '广西',
        positionX: 549,
        positionY: 738,
        nameX: 536,
        nameY: 761,
    },
    {
        name: '海南',
        positionX: 550,
        positionY: 844,
        nameX: 535,
        nameY: 868,
    },
    {
        name: '广东',
        positionX: 608,
        positionY: 752,
        nameX: 632,
        nameY: 751,
    },
    {
        name: '澳门',
        positionX: 615,
        positionY: 782,
        nameX: 598,
        nameY: 817,
    },
    {
        name: '香港',
        positionX: 640,
        positionY: 773,
        nameX: 649,
        nameY: 808,
    },
    {
        name: '福建',
        positionX: 702,
        positionY: 700,
        nameX: 683,
        nameY: 724,
    },
    {
        name: '台湾',
        positionX: 756,
        positionY: 739,
        nameX: 743,
        nameY: 764,
    },
    {
        name: '浙江',
        positionX: 732,
        positionY: 639,
        nameX: 682,
        nameY: 642,
    },
    {
        name: '上海',
        positionX: 752,
        positionY: 599,
        nameX: 759,
        nameY: 579,
    },
    {
        name: '江苏',
        positionX: 710,
        positionY: 549,
        nameX: 660,
        nameY: 553,
    },
    {
        name: '山东',
        positionX: 674,
        positionY: 494,
        nameX: 698,
        nameY: 494,
    },
    {
        name: '山西',
        positionX: 589,
        positionY: 481,
        nameX: 576,
        nameY: 505,
    },
    {
        name: '河北',
        positionX: 641,
        positionY: 453,
        nameX: 628,
        nameY: 476,
    },
    {
        name: '天津',
        positionX: 676,
        positionY: 443,
        nameX: 699,
        nameY: 446,
    },
    {
        name: '辽宁',
        positionX: 752,
        positionY: 388,
        nameX: 739,
        nameY: 413,
    },
    {
        name: '吉林',
        positionX: 790,
        positionY: 338,
        nameX: 741,
        nameY: 337,
    },
    {
        name: '黑龙江',
        positionX: 805,
        positionY: 273,
        nameX: 739,
        nameY: 273,
    },
];

/** 腾讯地图key */
export const QQMapKey = 'MVNBZ-LM2CJ-PAJFZ-KGYBA-RVQTE-7OFW7';

export function wxGetLocation(): Promise<wx.Location | null> {
    return new Promise((resolve, reject) => {
        wx.getLocation({
            type: 'gcj02',
            success: (res) => {
                resolve(res);
            },
            fail: (err) => {
                resolve(null);
            },
        });
    });
}

export const STORAGE_NAME = {
    NUMBER_TIME: 'NUMBER_TIME',
};

export const ActiveActivityId = process.env.RO_ACTIVITY_ID
